import React from "react";
import styles from "../CountAndExp/CountAndExperi.module.scss";

const data = [
  { value: "40+", label: "YEARS OF EXPERIENCE" },
  { value: "740+", label: "TRAINING CENTRES" },
  { value: "200+", label: "CITIES WORLDWIDE" },
  { value: "75 lakhs+", label: "STUDENTS TRAINED" },
  { value: "2 crores+", label: "PAN-INDIA ASSESSMENTS" },
];

const CountAndExperi: React.FC = () => {
  return (
    <div className="section">
      <div id="CountAndExperi" className={styles.CountAndExperi}>
        <div className="container">
          <div className="row g-5 justify-content-center">
            {data.map((item, index) => (
              // <div
              //   key={index}
              //   className={`${
              //     index === 0 || index === data.length - 1
              //       ? "col-lg-3"
              //       : "col-lg-2"
              //   } col-md-6 col-sm-12 ${styles.statItem}`}
              // >
              //   <h3 className="para">{item.value}</h3>
              //   <p className={`para ${styles.text} mb-0`}>{item.label}</p>
              // </div>
              <div
                key={item.value ? item.value : `${item.value}-${index}`}
                className={`col-xl-2 col-md-6 col-sm-6 col-6 ${styles.statItem}`}
              >
                <h3 className="cardHeading">
                  <strong>{item.value}</strong>
                </h3>
                <p className={`para2 ${styles.text} mb-0`}>{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountAndExperi;
